import { render, staticRenderFns } from "./SkeletonCommon.vue?vue&type=template&id=0cc0e210&scoped=true"
var script = {}
import style0 from "./SkeletonCommon.vue?vue&type=style&index=0&id=0cc0e210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0e210",
  null
  
)

export default component.exports